import React from "react";
import "./member-line-item.scss";

import {
  GSInfoGroup,
  GSCircleImage,
  GSButton,
} from "golfstatus_react_components";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { getDate } from "../../helpers/Dates";
import { useDispatch } from "react-redux";
import {
  resendUserInvitation,
  selectLoading,
} from "../../reducers/userSlice";
import { useSelector } from "react-redux";

const MemberLineItem = (props) => {
  const {
    id,
    roleLabel,
    user,
    createdAt,
  } = props;

  const dispatch = useDispatch();
  const sending = useSelector(selectLoading);

  // Existing users that are invited to be org members don't get invited, they're automatically added.
  const existingAccount = user?.invitationAcceptedAt;

  const getActivityText = () => {
    if (user?.invitationSentAt && !existingAccount) {
      return `Added on ${getDate(user?.invitationSentAt)}`;
    }
    if (existingAccount && user?.lastSignInAt) {
      return `Last Login on ${getDate(user?.lastSignInAt)}`;
    }
    if (existingAccount && !user?.lastSignInAt) {
      return `Account Created on ${getDate(createdAt)}`;
    }
  };

  const resendMemberInvite = (e) => {
    dispatch(resendUserInvitation(id));
    e?.stopPropagation?.();
  };

  const getInfoGroup = () => {
    const group = [
      {
        title: <GSCircleImage size="large" url={user?.avatar} />,
      },
      {
        fit: "stretch",
        sections: [
          {
            sectionItems: [],
          },
          {
            sectionItems: [
              {
                type: "secondary",
                value: <div className="user-type">{roleLabel}</div>,
              },
            ],
          },
        ],
      },
    ];
    if (user?.name) {
      group[1].sections[0].sectionItems.push(
        { type: "primary", value: user?.name },
        { type: "secondary", value: user?.email },
      );
    } else {
      group[1].sections[0].sectionItems.push(
        { type: "primary", value: user?.email },
      );
    }

    const activitySection = {
      sections: [
        {
          sectionItems: [
            {
              type: "secondary no-wrap flex-end flex-start-mobile",
              value: getActivityText(),
            },
          ],
        },
      ],
    };

    const resendSection = {
      sectionItems: [
        {
          type: "no-wrap flex-end flex-start-mobile",
          value: (
            <GSButton
              type="light-grey"
              title="Resend"
              buttonIcon={faPaperPlane}
              onClick={resendMemberInvite}
              isDisabled={sending?.includes?.("resendUserInvitation")}
            />
          ),
        },
      ],
    };

    if (!existingAccount) {
      activitySection?.sections?.push({ ...resendSection });
    }

    group.push({ ...activitySection });

    return group;
  };

  return (
    <member-line-item>
      <GSInfoGroup listType="mobile-vertical" dataGroups={getInfoGroup()} />
    </member-line-item>
  );
};

export default MemberLineItem;
